import React from 'react'
import axios from 'axios'
import { browserHistory } from 'react-router'
import { renderMoney } from '../../utils'
import myBgImg from '../../images/resell/my-bg.png'


class ResellMy extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            todayEarn: 0,
            totalEarn: 0,
        }
    }
    componentDidMount () {
        this.fetchMyInfo()
    }
    fetchMyInfo () {
        axios.get(`/api/resell/invoice/init`)
            .then(res => {
                const data = res.data.data
                this.setState({ todayEarn: data.today_earn, totalEarn: data.total_earn })
            })
    }
    render() {
        const { totalEarn, todayEarn } = this.state
        return (
            <div className="resell-my">
                <div className="header" style={{backgroundImage: `url(${myBgImg})`}}>
                    <div className="panel-left">
                        <div className="key">今日收益（元）</div>
                        <div className="value">{renderMoney(todayEarn)}</div>
                    </div>
                    <div className="panel-right">
                        <div className="key">累计收益（元）</div>
                        <div className="value">{renderMoney(totalEarn)}</div>
                    </div>
                    <div className="btn" onClick={e => location.assign('/wallet')}>提现</div>
                </div>
                <div className="content">
                    <div className="title"><b>合作管理</b></div>
                    <div className="cells">
                        <div className="cell" onClick={e => location.assign('/resell/order')}>合作订单</div>
                        <div className="cell" onClick={e => location.assign('/resell/liveroom')}>我合作的店铺</div>
                    </div>
                    {/* <div className="cells">
                        <div className="cell" onClick={e => location.assign('https://mp.weixin.qq.com/s?__biz=MzIyNDE5MTAxNw==&mid=502285241&idx=3&sn=9006652c665550b52987dba52d603904&chksm=701654ff4761dde936ae9fcee3c554a9ced65298a15745e341113dae51b73a7ee1561c12be50#rd')}>赚钱秘籍</div>
                    </div> */}
                </div>
            </div>
        )
    }
}

export default ResellMy


// WEBPACK FOOTER //
// ./src/pages/resell/ResellMy.js